export default __webpack_public_path__ + "static/media/bannersell.9f1cc217.jpg";